(function () {
  function getSelectedColorsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const colors = [];

    for (const [key, value] of params.entries()) {
      const k = key.toLowerCase();
      if (k.startsWith("filter.v.option") && k.includes("farbe")) {
        String(value || "")
          .split(",")
          .map(v => v.trim())
          .filter(Boolean)
          .forEach(v => colors.push(v.toLowerCase()));
      }
    }
    return colors;
  }

  function run() {
    const selectedColors = getSelectedColorsFromUrl();
    if (!selectedColors.length) return;

    document.querySelectorAll('script[data-variant-map]').forEach((dataEl) => {
      let payload;
      try { payload = JSON.parse(dataEl.textContent); } catch { return; }

      const optionNames = (payload.optionNames || []).map(s => String(s).toLowerCase());
      const colorIdx = optionNames.indexOf(String(payload.colorOptionName || "Farbe").toLowerCase());
      if (colorIdx === -1) return;

      const wanted = new Set(selectedColors);
      const match = (payload.variants || []).find(v =>
        v && v.image && Array.isArray(v.options) &&
        wanted.has(String(v.options[colorIdx] || "").toLowerCase())
      );
      if (!match) return;

      // Karte ist einfach das nächste sinnvolle Elternelement, das unser Image enthält
      const cardEl = dataEl.closest('li, article, .grid__item, div') || dataEl.parentElement;
      if (!cardEl) return;

      const imgEl = cardEl.querySelector('[data-product-card-image]');
      if (!imgEl) return;

      imgEl.src = match.image;
      imgEl.srcset = match.image;
      imgEl.removeAttribute("sizes");
    });
  }

  let t;
  const rerun = () => { clearTimeout(t); t = setTimeout(run, 50); };

  run();
  new MutationObserver(rerun).observe(document.documentElement, { childList: true, subtree: true });
})();
